
import styled from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import InputView from "../../../Componentes/Utils/InputView";
import Modal from "../../../Componentes/Utils/Modal";
import { useEffect, useState } from "react";
import useApi from "../../../hooks/useApi";
import { formatBRLFromCents } from "../../../Funcoes/Money";
import { formatarData } from "../../../Funcoes/FormatarData";
import SmallLoading from "../../../Componentes/Utils/SmallLoading";

const Titulo = styled.h2`
    margin: 0 0 5px 3px;
    font-size: 18px;
    color: #444;
    text-align: left;
`
const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`

const ModalViewItem = ({ isPedido, id, fecharModal }) => {

    const api = useApi();

    const [itemData, setItemData] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {

        setLoading(true);

        try {

            const url = isPedido ? `/Painel/API/ControleMedicao/GetPedido/index.php?id=${id}` : `/Painel/API/ControleMedicao/GetAditivo/index.php?id=${id}`;
            const { data } = await api.get(url);

            setItemData(data);

            console.log(data);

        } catch (e) {

            console.error(e);

        } finally {

            setLoading(false);

        }

    }

    useEffect(() => {
        fetchData();
    }, [])

    return (
        <>
            <Overlay state={true} >
                <Modal
                    header
                    close={fecharModal}
                >
                    {
                        loading ? (
                            <SmallLoading />
                        ) : (
                            <>
                                <Titulo>{isPedido ? "PEDIDO DE COMPRA" : "ADITIVO"}</Titulo>
                                <Wrapper>
                                    <InputView
                                        label="OBRA:"
                                        value={itemData ? itemData.obra : ""}
                                    />
                                    <InputView
                                        label="Nº PEDIDO DE COMPRA:"
                                        value={itemData ? itemData.num_pedido : ""}
                                    />
                                    <InputView
                                        label="VALOR FATURAMENTO:"
                                        value={itemData ? formatBRLFromCents(itemData.valor_faturamento) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="VALOR FATURAMENTO DIRETO:"
                                        value={itemData ? formatBRLFromCents(itemData.valor_faturamento_direto) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="VALOR TOTAL:"
                                        value={itemData ? formatBRLFromCents(itemData.valor_faturamento + itemData.valor_faturamento_direto) : "R$ 0,00"}
                                    />
                                    <InputView
                                        label="TIPO CONTRATO:"
                                        value={itemData ? itemData.tipo_contrato : ""}
                                    />
                                    <InputView
                                        label="NOME PROJETO:"
                                        value={itemData ? itemData.nome_projeto : ""}
                                    />
                                    <InputView
                                        label="PASP"
                                        value={itemData ? itemData.pasp : ""}
                                    />
                                    <InputView
                                        label="DESCRIÇÃO:"
                                        value={itemData ? itemData.descricao : ""}
                                    />
                                    <InputView
                                        label="CONTRATANTE:"
                                        value={itemData ? itemData.contratante : ""}
                                    />
                                    <InputView
                                        label="OBSERVAÇÕES:"
                                        value={itemData ? itemData.observacoes : ""}
                                        textarea
                                    />
                                    <InputView
                                        label="N DO CONTRATO:"
                                        value={itemData ? itemData.num_contrato : ""}
                                    />
                                    <InputView
                                        label="DATA DO CONTRATO:"
                                        value={itemData ? formatarData(itemData.data_contrato) : ""}
                                    />
                                    <InputView
                                        label="ART"
                                        value={itemData ? itemData.art : ""}
                                    />
                                    <InputView
                                        label="CNO"
                                        value={itemData ? itemData.cno : ""}
                                    />
                                </Wrapper>
                            </>
                        )
                    }

                </Modal>
            </Overlay>
        </>
    )

}

export default ModalViewItem;